export default __webpack_public_path__ + "static/media/us_0.4f5d79cd.mp3";